import { useEffect, useState } from "react";
import api from "../../api/api";
import ProductivityModal from "./ProductivityModal";
import "./ProductivityCard.css";

function ProductivityCard({onProductivitySuccess}) {
  const [streak, setStreak] = useState(0);
  const [marked, setMarked] = useState(false);
  const [open, setOpen] = useState(false);

  const fetchData = async () => {
    try {
      const streakRes = await api.get("/streak");
      setStreak(streakRes.data.currentStreak || 0);

      const todayRes = await api.get("/productivity/today");
      setMarked(todayRes.data.marked);
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <>
      <div className="productivity-card">
        <h3>Daily Productivity</h3>
        <h4>( Project / Practice / Coding )</h4>

        <div className="streak-visual">
          <div className="streak-block old">
            <span className="flame">🔥</span>
            <span className="number">{streak}</span>
          </div>

          <div className="streak-arrow">→</div>

          <div
            className={`streak-block new ${
              marked ? "active" : "preview"
            }`}
          >
            <span className="flame">🔥</span>
            <span className="number">
              {streak + (marked ? 0 : 1)}
            </span>
          </div>
        </div>

        <p className="streak-note">
          Earn your streak through honest work. Discipline compounds.
        </p>
        {!marked ? (
          <button
            className="mark-btn"
            onClick={() => setOpen(true)}
          >
            Mark Today’s Productivity
          </button>
        ) : (
          <div className="completed-box">
            ✅ Today's Streak Completed
            <p>You showed up today. Keep going.</p>
          </div>
        )}
      </div>

      {open && (
        <ProductivityModal
          onClose={() => setOpen(false)}
          streak={streak}
          onSuccess={() => {
            fetchData();
            onProductivitySuccess();
            setOpen(false);
          }}
        />
      )}
    </>
  );
}

export default ProductivityCard;